/**
 * Backoffice · Catálogo de emails
 * Endpoints /api/backoffice/emails/* — listar, previsualizar y enviar pruebas.
 */

import { ApiClient } from './client';

export interface BackofficeEmailInfo {
  id: string;
  label: string;
  description: string;
  trigger: string;
}

export interface BackofficeEmailPreview {
  subject: string;
  html: string;
}

/** Lista de emails del sistema (metadatos). */
export function listBackofficeEmails(): Promise<BackofficeEmailInfo[]> {
  return ApiClient.get<BackofficeEmailInfo[]>('/backoffice/emails');
}

/** HTML renderizado del email (para la vista previa). */
export function previewBackofficeEmail(id: string): Promise<BackofficeEmailPreview> {
  return ApiClient.get<BackofficeEmailPreview>(`/backoffice/emails/${id}/preview`);
}

/**
 * Envía el email al destinatario indicado (o al admin logueado si se omite).
 * `name` personaliza el saludo — necesario para enviar de verdad la invitación
 * manual a un alumno y no saludarle con el nombre del admin.
 */
export function sendBackofficeTestEmail(
  id: string,
  to?: string,
  name?: string
): Promise<{ ok: boolean; to: string }> {
  return ApiClient.post<{ ok: boolean; to: string }>(`/backoffice/emails/${id}/test`, { to, name });
}
